export default __webpack_public_path__ + "static/media/lp-sec05_bg1245.4b6c3512.png";